/**
 * The seven ComPlan roles (R1.7).
 *
 * The identifiers are the values the database and the RLS helper functions use
 * (`complan.has_role('commercial_planning')` in design.md, "Authorization
 * service"), so a role name crosses the SQL boundary unchanged and no mapping
 * layer can drift.
 */
/**
 * Every role, in the order Requirement 1 criterion 7 lists them.
 *
 * Exported as data so the role subset generator of Property 2 and the role
 * administration screen enumerate the same seven values rather than each
 * carrying its own copy.
 */
export const COMPLAN_ROLES = Object.freeze([
    'commercial_planning',
    'platform_owner',
    'channel_owner',
    'field_force_leadership',
    'dte_csc_stakeholder',
    'management_viewer',
    'system_administrator',
]);
/** Narrows an unvalidated string, e.g. a stored role assignment, to a known role. */
export function isComPlanRole(value) {
    return COMPLAN_ROLES.includes(value);
}
//# sourceMappingURL=roles.js.map